import React from 'react';
import '../../styles/shared.css';
import './TransferPage.css';

const TransferPage: React.FC = () => {
  return (
    <div className="page-container transfer-page">
      <div className="page-header">
        <div className="header-content">
          <h1>调课/转班</h1>
        </div>
      </div>
      
      <div className="content-container">
        <div className="transfer-options">
          <div className="option-card">
            <h3>调课申请</h3>
            <p>申请调整课程时间，灵活安排学习计划</p>
            <button className="btn btn-primary">申请调课</button>
          </div>
          <div className="option-card">
            <h3>转班申请</h3>
            <p>申请转到其他班级，选择更适合的课程</p>
            <button className="btn btn-primary">申请转班</button>
          </div>
        </div>
        
        <div className="transfer-history">
          <h3>申请记录</h3>
          <div className="empty-state">
            <p>暂无调课/转班申请记录</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferPage;